import {useMapEvents} from "react-leaflet";

const ClickLocalizer = ({onClick, disabled}) => {

    const map = useMapEvents({
        click(e) {
            if(disabled) {
                return;
            }
            onClick(e.latlng)
        }
    })
}

export default ClickLocalizer;